<template>
    <div class="login-wrapper">
            <h1>{{ $t('Reset Your Password') }}</h1>
            <p>{{ $t('We’ll email you instructions to reset your password.') }}</p>
            <form @submit="submit">
                <label>
                    <span>{{ $t('Email') }}</span>
                    <input type="email" v-model="email" placeholder="name@email.com">
                </label>
                <button type="submit" class="button-blue">{{ $t('Submit') }}</button>
            </form>
            <a style="text-align: center;text-decoration: none;" href="/"><span class="return-login blue">{{ $t('Return to login') }}</span></a>
        </div>
</template>

<script>
import { resetPassword } from '../api/auth.js';
import i18n from "@/plugins/i18n";
export default {

  data() {
    return {
        email:''
    };
  },
  methods: {
    submit(e) {
      e.preventDefault();
      resetPassword(this.email)
    },

  },

  name: "ResetPassword",
  components: {
  },
  async mounted() {

    i18n.locale = this.$store.state.locale

  }

};
</script>
